module.exports = __webpack_public_path__ + "img/ribatei.a02a6399.png";